// Dashboard
export const CSP_DASHBOARD_LOADING = 'CSP_DASHBOARD_LOADING'
export const CSP_DASHBOARD_LOADED = 'CSP_DASHBOARD_LOADED'
export const CSP_DASHBOARD_FAILED = 'CSP_DASHBOARD_FAILED'

// Sync
export const CSP_SYNC_TRIGGERING = 'CSP_SYNC_TRIGGERING'
export const CSP_SYNC_TRIGGERED = 'CSP_SYNC_TRIGGERED'
export const CSP_SYNC_TRIGGER_FAILED = 'CSP_SYNC_TRIGGER_FAILED'

// Tenants
export const CSP_TENANTS_LOADED = 'CSP_TENANTS_LOADED'
export const CSP_UNMAPPED_TENANTS_LOADED = 'CSP_UNMAPPED_TENANTS_LOADED'

// Mappings + contact override
export const CSP_TENANT_UPDATING = 'CSP_TENANT_UPDATING'
export const CSP_TENANT_UPDATED = 'CSP_TENANT_UPDATED'
export const CSP_TENANT_UPDATE_FAILED = 'CSP_TENANT_UPDATE_FAILED'

// Notifications
export const CSP_NOTIFICATIONS_LOADED = 'CSP_NOTIFICATIONS_LOADED'

// Settings
export const CSP_SETTINGS_LOADING = 'CSP_SETTINGS_LOADING'
export const CSP_SETTINGS_LOADED = 'CSP_SETTINGS_LOADED'
export const CSP_SETTINGS_SAVING = 'CSP_SETTINGS_SAVING'
export const CSP_SETTINGS_SAVED = 'CSP_SETTINGS_SAVED'
export const CSP_SETTINGS_FAILED = 'CSP_SETTINGS_FAILED'

// Products (curation)
export const CSP_PRODUCTS_LOADING = 'CSP_PRODUCTS_LOADING'
export const CSP_PRODUCTS_LOADED = 'CSP_PRODUCTS_LOADED'
export const CSP_PRODUCTS_FAILED = 'CSP_PRODUCTS_FAILED'
export const CSP_PRODUCT_UPDATING = 'CSP_PRODUCT_UPDATING'
export const CSP_PRODUCT_UPDATED = 'CSP_PRODUCT_UPDATED'
export const CSP_PRODUCT_UPDATE_FAILED = 'CSP_PRODUCT_UPDATE_FAILED'
